import ActivitiesView from "@components/order/components/activity/ActivitiesView";
import AppContext from "@helpers/context";
import {
  addVehicleActivity,
  getVehicleActivityList,
} from "@network/api/vehicle";

import { Notifications } from "d-react-components";
import { map } from "lodash";
import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

const VehicleDetailActivity = () => {
  const { vehicleDetail } = useContext(AppContext);
  const activityList = useRef(null);
  const { t } = useTranslation();

  const source = (paging: any) => {
    const body = { id: vehicleDetail?.id };
    return getVehicleActivityList(body, paging);
  };

  const transformer = (res: any) => {
    const activityList = res?.data?.data?.activities ?? [];
    return map(activityList, (item) => ({
      ...item,
      files: map(item.attachment, (attItem) => attItem?.attachment),
    }));
  };

  const onClickSendComment = (comment: any, attachment: any) => {
    const body = {
      id: vehicleDetail?.id,
      comment,
      attachment: map(attachment, (item) => item?.key),
    };
    return addVehicleActivity(body).then(() => {
      Notifications.showSuccess(t("addCommentSuccess"));
    });
  };

  return (
    <ActivitiesView
      hideType
      source={source}
      transformer={transformer}
      setRef={(listRefParams: any) => (activityList.current = listRefParams)}
      onClickSendComment={onClickSendComment}
      isInstantUploadAttach
    />
  );
};

export default VehicleDetailActivity;
